module.exports = "/_next/static/images/Hero1-54023d2d304f149f9c742fa6916ce068.png";